// Port of bootstrap $grid-breakpoints
export const gridBreakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const MOBILE_WIDTH = gridBreakpoints.sm;
export const DESKTOP_WIDTH = gridBreakpoints.lg;
